import { render, staticRenderFns } from "./TodoDetailsComponent.vue?vue&type=template&id=728cf17d&scoped=true"
import script from "./TodoDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./TodoDetailsComponent.vue?vue&type=script&lang=ts"
import style0 from "./TodoDetailsComponent.vue?vue&type=style&index=0&id=728cf17d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728cf17d",
  null
  
)

export default component.exports